import { useEffect, useRef } from "react";
import { useReveal } from "@/lib/animations";
import { FunnelHero } from "@/components/funnel/FunnelHero";
import { KeyNumbers } from "@/components/funnel/KeyNumbers";
import { PainPoints } from "@/components/funnel/PainPoints";
import { StepsTimeline } from "@/components/funnel/StepsTimeline";
import { FloorExplainer } from "@/components/funnel/FloorExplainer";
import { FunnelFAQ } from "@/components/funnel/FunnelFAQ";
import { FunnelProof } from "@/components/funnel/FunnelProof";
import { FunnelCTA } from "@/components/funnel/FunnelCTA";
import { StickyCTA } from "@/components/funnel/StickyCTA";

/** Reusable funnel-style landing template — any product with a `funnel` config renders here. */
export default function ProductFunnel({ product, MotionGraphic }) {
  const ref = useRef(null);
  useReveal(ref);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [product.id]);

  const quoteTo = `/quote?product=${encodeURIComponent(product.name)}`;
  const article = /^[AEIOU]/i.test(product.tag) ? "an" : "a";
  const shared = { product, quoteTo, article };

  return (
    <main ref={ref} data-testid={`product-funnel-${product.id}`} className="bg-[#F9F6F0]">
      <FunnelHero {...shared} MotionGraphic={MotionGraphic} />
      <KeyNumbers product={product} />
      <PainPoints product={product} />
      <StepsTimeline product={product} />
      {product.funnel.explainer !== false && <FloorExplainer product={product} />}
      <FunnelFAQ product={product} />
      <FunnelProof product={product} />
      <FunnelCTA {...shared} />
      <StickyCTA {...shared} />
    </main>
  );
}
